/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_Full_AnalyticsInputs */

const en_pricing_feature_full_analytics = /** @type {(inputs: Pricing_Feature_Full_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full analytics dashboard`)
};

const de_pricing_feature_full_analytics = /** @type {(inputs: Pricing_Feature_Full_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollständiges Analysen-Dashboard`)
};

const fr_pricing_feature_full_analytics = /** @type {(inputs: Pricing_Feature_Full_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tableau de bord d'analyses complet`)
};

const es_pricing_feature_full_analytics = /** @type {(inputs: Pricing_Feature_Full_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel de análisis completo`)
};

const it_pricing_feature_full_analytics = /** @type {(inputs: Pricing_Feature_Full_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard analitica completa`)
};

const nl_pricing_feature_full_analytics = /** @type {(inputs: Pricing_Feature_Full_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volledig analytisch dashboard`)
};

const pl_pricing_feature_full_analytics = /** @type {(inputs: Pricing_Feature_Full_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pełna analityka`)
};

const fi_pricing_feature_full_analytics = /** @type {(inputs: Pricing_Feature_Full_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Täydellinen analytiikkapaneeli`)
};

const da_pricing_feature_full_analytics = /** @type {(inputs: Pricing_Feature_Full_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuldt analysedashboard`)
};

const sv_pricing_feature_full_analytics = /** @type {(inputs: Pricing_Feature_Full_AnalyticsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fullständigt analysinstrumentpanel`)
};

/**
* | output |
* | --- |
* | "Full analytics dashboard" |
*
* @param {Pricing_Feature_Full_AnalyticsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_full_analytics = /** @type {((inputs?: Pricing_Feature_Full_AnalyticsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_Full_AnalyticsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_feature_full_analytics(inputs)
	if (locale === "fr") return fr_pricing_feature_full_analytics(inputs)
	if (locale === "es") return es_pricing_feature_full_analytics(inputs)
	if (locale === "it") return it_pricing_feature_full_analytics(inputs)
	if (locale === "nl") return nl_pricing_feature_full_analytics(inputs)
	if (locale === "pl") return pl_pricing_feature_full_analytics(inputs)
	if (locale === "fi") return fi_pricing_feature_full_analytics(inputs)
	if (locale === "da") return da_pricing_feature_full_analytics(inputs)
	if (locale === "sv") return sv_pricing_feature_full_analytics(inputs)
	return en_pricing_feature_full_analytics(inputs)
});